import classNames from 'classnames';
import React, { Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from 'atoms/Loader/Loader';
import Toast from 'atoms/Toast';
import ModalsManager from 'containers/ModalsManager';
import SidebarsManager from 'containers/SidebarsManager/SidebarsManager';
import SpecificationProblems from 'containers/Specifications/SpecificationDetails/SpecificationProblems/SpecificationProblems';
import useInboxMessageSubscription from 'hooks/useInboxMessageSubscription';
import useSharedNotificationSubscription from 'hooks/useSharedNotificationSubscription';
import ToastsList from 'molecules/ToastsList';
import Menubar from 'organisms/Menubar/Menubar';
import { selectAllToasts } from 'store/toastsSlice';
import styles from './Layout.module.scss';
function Layout({ children, location }) {
    var _a, _b;
    const layoutState = useSelector((state) => state.layout);
    const toasts = useSelector(selectAllToasts);
    const mainContentClass = classNames(styles.main, { [styles.full]: layoutState.showMenu });
    useEffect(() => {
        document.documentElement.classList.toggle('dark', layoutState.theme === 'dark');
    }, [layoutState.theme]);
    // Subscribe to real-time notifications globally
    useSharedNotificationSubscription();
    // Subscribe to inbox messages globally for unread count
    useInboxMessageSubscription();
    // Reset scroll position when route changes
    useEffect(() => {
        const mainContent = document.getElementById('mainContent');
        if (mainContent) {
            mainContent.scrollTop = 0;
        }
    }, [location.pathname]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Menubar, null),
        React.createElement("main", { className: mainContentClass },
            React.createElement("div", { className: styles.content },
                React.createElement(Suspense, { fallback: React.createElement(Loader, null) }, children))),
        ((_a = layoutState.showModals) === null || _a === void 0 ? void 0 : _a.some((modal) => modal.name === 'specificationProblems')) && (React.createElement(SpecificationProblems, { preview: Boolean((_b = layoutState.showModals) === null || _b === void 0 ? void 0 : _b.find((modal) => { var _a; return (_a = modal === null || modal === void 0 ? void 0 : modal.data) === null || _a === void 0 ? void 0 : _a.preview; })) })),
        React.createElement(ModalsManager, null),
        React.createElement(SidebarsManager, null),
        React.createElement(ToastsList, null, toasts.map((toast) => (React.createElement(Toast, { key: toast.id, id: toast.id, theme: toast.theme, color: toast.color, title: toast.title, description: toast.description, autoClose: toast.autoClose }))))));
}
export default React.memo(withRouter(Layout));
